import React from 'react';
import Row from './Row';
import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';
import EmptyList from 'Components/EmptyList';
import {Input, inputStyleClasses} from 'Components/Input';
import moment from 'moment';

const SEARCHABLE_FIELDS = ['name', 'type'];

export default class FamiliesList extends React.Component {
  defaultState = {
    activePage: 1,
    selectedRowsCount: 10,
    sortedBy: 'submissionDate',
    sortAsc: -1,
    filter: {},
    searchString:'',
  };

  constructor(props) {
    super(props);

    const storedState = props.user.getStoredState('familyListState', this.defaultState);
    props.user.updateURLSearchString(storedState);

    this.state = {
      ...this.defaultState,
      ...storedState,
    };
  }

  componentWillUnmount() {
    const {user} = this.props;

    user.saveState('familyListState', this.state, []);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params !== this.props.match.params) {
      this.props.user.saveState('familyListState', this.state, []);
    }
  }

  handleRowsSelect = (rowsCountSelected, totalRowsCount) => {
    const {user} = this.props;

    const selectedRowsCount = (rowsCountSelected && rowsCountSelected < totalRowsCount) ? rowsCountSelected : 0;

    const state = {selectedRowsCount, activePage: 1};
    this.setState(state, user.updateURLSearchString(state));
  };

  _handleActivePageChange = activePage => {
    const {user} = this.props;

    this.setState({activePage}, () => {user.updateURLSearchString({activePage});});
  };

  _sortList = (a, b) => {
    const {sortedBy, sortAsc} = this.state;

    switch (sortedBy) {
      case 'submissionDate':
        return moment(a.submissionDate).isAfter(b.submissionDate) ? sortAsc : -sortAsc;
      case 'componentType':
        return a.type.componentTypeName.toLowerCase() > b.type.componentTypeName.toLowerCase() ? sortAsc : -sortAsc;
      default:
        return (a[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ') > (b[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ') ? sortAsc : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    const {user} = this.props;

    this.setState(prevState => ({sortedBy, sortAsc: -prevState.sortAsc, activePage: 1}), () => {
      user.updateURLSearchString({sortedBy: this.state.sortedBy, sortAsc: this.state.sortAsc, activePage: 1});
    });
  };

  _filterList = familiesList => {
    const {filter, searchString} = this.state;

    const doesSearchableFieldsContainSearchString = (element) => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase()
            .includes(searchString.toLowerCase())) return true;
        }
      }
      return false;
    };

    return familiesList.filter(element => {
      for (let filterFieldName in filter) {
        switch (filterFieldName) {
          case 'categoryId':
            if (element.type[filterFieldName] !== filter[filterFieldName]) {
              return false;
            }
            break;
          case 'componentType':
            if (element.type.componentTypeCode !== filter[filterFieldName]) {
              return false;
            }
            break;
          default:
            if (element[filterFieldName] !== filter[filterFieldName]) {
              return false;
            }
        }
      }
      return (!searchString || doesSearchableFieldsContainSearchString(element));
    });
  };

  handleSearchStringInput = value => {
    const {user} = this.props;
    this.setState({searchString:value, activePage:1}, () => {user.updateURLSearchString({searchString:value});});
  };

  handleSelectFilter = filterFieldName => filterElement => {
    const {user} = this.props;
    const newFilterFieldValue = filterElement.value !== undefined ? filterElement.value : filterElement;
    let newFilterState = this.state.filter;

    if (newFilterFieldValue === 'All') delete newFilterState[filterFieldName];
    else newFilterState[filterFieldName] = newFilterFieldValue;

    if (filterFieldName === 'categoryId') delete newFilterState.componentType;

    this.setState({filter: newFilterState, activePage: 1},
      () => {
        user.updateURLSearchString({filter: this.state.filter, activePage: 1});
      }
    );
  };

  _getList = () => {
    const {activePage, selectedRowsCount, sortedBy} = this.state;
    const {user, createFamilyActionsList, performFamilyActionFunction, families,
      familiesRequestInProcess, updateFamiliesListEntry} = this.props;

    let resultList = [];
    let resultLength = 0;

    if (!families.length) {
      if (familiesRequestInProcess) {
        resultList = [
          <div key="spinner" className='ect-spinner _height_120'>
            <div className='ect-spinner__image'  style={{width: 50, height: 50}} />
          </div>
        ];
      } else {
        resultList = [
          <EmptyList key="empty">
            No families for selected manufacturer.
          </EmptyList>
        ];
      }
    } else {
      const filteredList = this._filterList(families).sort(this._sortList);
      const sliceFrom = (activePage - 1) * selectedRowsCount;
      const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

      if (!filteredList.length) {
        resultList = [
          <EmptyList key="empty">
            No families found with selected filters.
          </EmptyList>
        ];
      } else {
        resultList = filteredList.slice(sliceFrom, sliceTo).map((family, index) => {
          return (
            <Row
              key={family.id}
              user={user}
              sortedBy={sortedBy}
              family={family}
              isOdd={!!(index % 2)}
              availableActionsList={createFamilyActionsList(family.status)}
              performActionFunction={performFamilyActionFunction}
              updateFamiliesListEntry={updateFamiliesListEntry}
            />
          );
        });
        resultLength = filteredList.length;
      }
    }

    return {
      resultList,
      resultLength
    };
  };

  render() {
    const {types, categories} = this.props;
    const {activePage, selectedRowsCount, filter, sortedBy, sortAsc, searchString} = this.state;
    const {resultList, resultLength} = this._getList();

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper list-scene__content-wrapper'>
          <header className='scene__scene-header list-scene__scene-header'>
            Family List
            <Input
              mainWrapperClassName='list-scene__header-search-field-wrapper'
              styleClass={inputStyleClasses.searchBar}
              placeholder='Type here to search'
              maxLength={250}
              value={searchString}
              onChange={this.handleSearchStringInput}
            />
          </header>

          <FiltersSection
            outCount={resultLength}
            handleRowsSelect={this.handleRowsSelect}
            rowsCount={selectedRowsCount}
            handleSelectFilter={this.handleSelectFilter}
            filterState={filter}
            types={types}
            categories={categories}
          />

          <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />

          {resultList}

          <footer className='list-scene__footer'>
            <RowsSelector
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
              handleRowsSelect={this.handleRowsSelect}
            />
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this._handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/FamilyList/index.jsx